import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../images/Infomanav.svg";
import "./LoginSplash.css";

/** Time on splash after login succeeds, before navigating (full / reduced motion). */
const SPLASH_HOLD_MS = 3200;
const SPLASH_HOLD_MS_REDUCED = 900;

/**
 * Post-login splash — colorful field opens from center (iris); content on frosted sheet.
 */
const LoginSplash = ({ to }) => {
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const isPending = !to;

    useEffect(() => {
        let raf = requestAnimationFrame(() => setVisible(true));
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            cancelAnimationFrame(raf);
            document.body.style.overflow = prevOverflow;
        };
    }, []);

    useEffect(() => {
        if (!to) return undefined;

        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const delayMs = reduced ? SPLASH_HOLD_MS_REDUCED : SPLASH_HOLD_MS;

        const timer = setTimeout(() => {
            navigate(to, { replace: true });
        }, delayMs);

        return () => clearTimeout(timer);
    }, [to, navigate]);

    return (
        <div
            className={`login-splash${visible ? " login-splash--visible" : ""}${isPending ? " login-splash--pending" : " login-splash--ready"}`}
            role="status"
            aria-live="polite"
            aria-label={isPending ? "Signing in" : "Opening your trading workspace"}
        >
            <div className="login-splash__mat" aria-hidden />

            <div className="login-splash__colorfield" aria-hidden>
                <span className="login-splash__orb login-splash__orb--1" />
                <span className="login-splash__orb login-splash__orb--2" />
                <span className="login-splash__orb login-splash__orb--3" />
            </div>

            <div className="login-splash__wrap">
                <div className="login-splash__sheet">
                    <div className="login-splash__content">
                        <div className="login-splash__logo-wrap">
                            <img src={Logo} alt="" className="login-splash__logo" />
                        </div>

                        <p className="login-splash__eyebrow">
                            {isPending ? "Signing in" : "Ready"}
                        </p>

                        <h1 className="login-splash__title" key={isPending ? "p" : "r"}>
                            {isPending ? "One moment" : "You're in"}
                        </h1>

                        <p className="login-splash__hint" key={isPending ? "ph" : "rh"}>
                            {isPending
                                ? "Securely connecting to your broker."
                                : "Opening your workspace."}
                        </p>

                        <div className="login-splash__bar" aria-hidden>
                            <div className="login-splash__bar-fill" />
                        </div>

                        <div className="login-splash__chips" aria-hidden>
                            {["Portfolio", "Positions", "Orders", "Watchlist"].map((label) => (
                                <span key={label} className="login-splash__chip">
                                    {label}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginSplash;
